import React from 'react';
import SettingCard from './SettingCard';
import { panelLabel } from '../../utils/panelLabels';
import { useSettingsReadOnly } from './readOnlyContext';

// A DM510's Misc page: the two panel settings that have no 2500i page to sit on,
// the product and the dryer-off rate, both written to the panel, and two facts
// read back for the support call, the temperature unit and the panel's software.
// The panel stores a written value only when its own store trigger fires, so a
// change may not survive a power cut at the panel; the live value on screen is
// always what the panel holds now.
const PRODUCTS = [
  { value: 3, label: 'Corn' },
  { value: 4, label: 'Beans' },
  { value: 5, label: 'Wheat' },
  { value: 6, label: 'Canola' },
  { value: 7, label: 'Corn (hot)' },
  { value: 8, label: 'Beans (white)' },
  { value: 9, label: 'Sunflower' },
  { value: 10, label: 'Rice' }
];

const Panel510Setup = ({ getSettingValue, handleEdit }) => {
  const readOnly = useSettingsReadOnly();
  const product = getSettingValue('product_number');
  const offRate = getSettingValue('dryer_discharge_off_rate');
  const unit = getSettingValue('temperature_unit');
  const version = getSettingValue('panel_software_version');

  const unitLabel = unit.value === null || unit.value === undefined ? null
    : (unit.value === 1 || unit.value === '1' || unit.value === true ? 'Celsius' : 'Fahrenheit');

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-3">{readOnly ? 'Held by the panel' : 'Written to the panel'}</h3>
        <div className="grid grid-cols-2 gap-4">
          <SettingCard
            name="Product"
            value={product.value === null || product.value === undefined ? null : Number(product.value)}
            type="select"
            options={PRODUCTS}
            onEdit={(_, value) => handleEdit('product_number', value)}
          />
          <SettingCard
            name={panelLabel('dryer_discharge_off_rate', 'Dryer Off Rate')}
            value={offRate.value}
            min={offRate.minRange}
            max={offRate.maxRange}
            onEdit={(_, value) => handleEdit('dryer_discharge_off_rate', value)}
          />
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-3">Read from the panel</h3>
        <div className="grid grid-cols-2 gap-4">
          <SettingCard name="Temperature Unit" value={unitLabel} showButton={false} />
          <SettingCard name="Panel Software" value={version.value} showButton={false} />
        </div>
      </div>
    </div>
  );
};

export default Panel510Setup;
